import { Box, Link, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onCreate: () => void
  onEdit: () => void
}

const NewConceptBox = ({ onCreate, onEdit }: Props) => {
  return (
    <Box
      padding="s24"
      width="full"
      border={{ all: { color: 'viridian100', style: 'solid', width: 's1' } }}
      borderRadius={{ all: 'abs004' }}
      background="viridian100"
    >
      <Text.Normal>
        {i18n.t('payroll_bundle.results_payments.results.concept_selector.is_data_missing')}
      </Text.Normal>
      <Box gap="s8" paddingTop="s8" justifyContent="flexStart">
        <Link.Touchable onClick={onCreate}>
          {i18n.t('payroll_bundle.results_payments.results.concept_selector.add_concept')}
        </Link.Touchable>
        <Link.Touchable onClick={onEdit}>
          {i18n.t('payroll_bundle.results_payments.results.concept_selector.edit_concept')}
        </Link.Touchable>
      </Box>
    </Box>
  )
}

export default NewConceptBox
